import { createSelector } from 'reselect';
import getOrdering from './getOrdering';

const getCouponMinimumSpendingInclusive = createSelector(
  [getOrdering],
  (ordering: OrderingState) => Boolean(ordering.config.includeDiscountMinSpend),
);

export default getCouponMinimumSpendingInclusive;
